import React, { useState, useEffect } from 'react';
import './styles.scss';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AccordionActions from '@material-ui/core/AccordionActions';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CircularProgress from '@material-ui/core/CircularProgress';
import { NotificationManager } from 'react-notifications';
import { MdSave,MdClose,MdCreate } from "react-icons/md";
import { createTheme, ThemeProvider } from '@material-ui/core/styles';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MainComponent(props) {
    const theme = createTheme({
        palette: {
            primary: {
                main: '#4facfe',
            },
            secondary: {
                main: '#4facfe',
            },
        },
    });
    useEffect(() => {
        props.GetDataMain();
        props.GetDataUser();   
        // eslint-disable-next-line    
    }, []
    );    
    useEffect(() => {
        if (props.isResult) {
            props.GetDataMain();
            props.GetDataUser();
        }
        // eslint-disable-next-line
    }, [props.isResult])
    var curr = new Date();
    curr.setDate(curr.getDate());
    // eslint-disable-next-line
    const [expanded, setExpanded] = React.useState('panel1');
    const [User, SetUser] = useState();
    const [valueMenu, setMenu] = useState();
    const [Path, setPath] = useState();
    const [Description, setDescription] = useState();
    const [Level, setLevel] = useState();
    const [valueMenucha, setMenuCha] = useState();
    const [valueMenuAuthor, setMenuAuthor] = useState();
    const [Operation, setOperation] = useState();
    const [showform, setshow] = useState(false);
    const [showTaoMenu, setshowTaoMenu] = useState(true);
    // eslint-disable-next-line
    const [valueThaotac, setValueThaotac] = useState([
        { title: 'Tất cả', value: -1 },
        { title: 'Xem', value: 0 },
        { title: 'Cập nhật', value: 1 },
        { title: 'Thêm mới', value: 2 },
        { title: 'Xóa', value: 3 }
    ]);
    // eslint-disable-next-line
    const [valueUser, setValueUser] = useState(DataUser);
    const handleMenu = (event) => {
        setMenu(event.target.value);
    };    
    const handlePath = (event) => {
        setPath(event.target.value);
    };
    const handleDescription = (event) => {
        setDescription(event.target.value);
    };
    const handleLevel = (event) => {
        setLevel(event.target.value);
    };
    // const handleshowopen = () => {
    //     setshow(true);
    //     setshowTaoMenu(false);
    // };
    const handleTaomenu = () => {
        setshow(false);
        setshowTaoMenu(true);
    };
    const handleshowclose = () => {
        setshow(false);
        setshowTaoMenu(true);
    };
    const saveTask = () => {
        if (!valueMenu) {
            NotificationManager.error("Vui lòng nhập tên menu");
            return false;
        }
        if (!valueMenucha) {
            NotificationManager.error("Vui lòng chọn tên menu cha");
            return false;
        }
        if (!Path) {
            NotificationManager.error("Vui lòng nhập tên đường dẫn");
            return false;
        }
        if (!Level) {
            NotificationManager.error("Vui lòng nhập level");
            return false;
        }
        const Dataset = {
            "Name": valueMenu,
            "Parent": valueMenucha!== undefined ? valueMenucha.value:"",
            "Url": Path,
            "Description": Description,
            "Level": Level
        };
        props.SetDataMain(Dataset);
    };


    const savepermission = () => {
        if (!valueMenuAuthor) {
            NotificationManager.error("Vui lòng chọn menu !");
            return false;
        }
        if (!User) {
            NotificationManager.error("Vui lòng chọn list user !");
            return false;
        }
         if (!Operation) {
            NotificationManager.error("Vui lòng chọn thao tác");
            return false;
        }
        let Operation1="";
        let User1="";
        if(Operation){
            Operation.forEach((item, i) => {
                Operation1 = Operation1 + "," + item.value;
            });    
        }     
        if(User[0].value===-1){
            User1 = ",-1";
        }  
        else
        {
            User.forEach((item, i) => {
                User1 = User1 + "," + item.value;
            });   
        }
        const DataPermission = {
            "ID": valueMenuAuthor?valueMenuAuthor.value:"0",
            "ListUser": User1.substring(1),
            "ListOperation":  Operation1.substring(1)
        };
        props.SetDataPermission(DataPermission);
        window.location.reload();
    };

    const fn_SetMenuCha = (newValue) => {
        setMenuCha(newValue);
    }
    const fn_Setoperation = (newValue, reason) => {
        if (reason === "select-option") {
            if (newValue.some(x => x.value === -1) || (!newValue.some(x => x.value === -1) && newValue.length === valueThaotac.length - 1)) {
                setOperation(valueThaotac);
            }
            else {
                setOperation(newValue);
            }
        }
        else if (reason === "remove-option") {
            if (newValue.some(x => x.value === -1)) {
                var index = newValue.findIndex(x => x.value === -1);
                setOperation([...newValue.slice(0, index),
                ...newValue.slice(index + 1)]);
            }
            else if (!newValue.some(x => x.value === -1) && newValue.length === valueThaotac.length - 1) {
                setOperation();
            }
            else {
                setOperation(newValue);
            }
        }
        else if (reason === "clear") {
            setOperation();
        }
    }
    const fn_SetMenuAuthor = (newValue) => {
        setMenuAuthor(newValue);
    }

    const menucha = [];
    const menuAuthor = [];
    menucha.push({ title: "IsParent ***", value: -2 });
    if (props.DataMain !== undefined && props.DataMain) {
        // eslint-disable-next-line
        props.DataMain.map((item, index) => {
            menucha.push({ title: item.name, value: item.id });
            menuAuthor.push({ title: item.name, value: item.id });
        });
    };
    const DataUser = [];
    DataUser.push({ title: "Tất cả", value: -1 });
    if (props.DataUser !== undefined && props.DataUser) {
        // eslint-disable-next-line
        props.DataUser.map((item, index) => {
            DataUser.push({ title: item.email, value: item.userCode?item.userCode:0 });
        });
    };

    
    const fn_SetUser = (newValue, reason) => {
        if (reason === "select-option") {
            if (newValue.some(x => x.value === -1) || (!newValue.some(x => x.value === -1) && newValue.length === valueUser.length - 1)) {
                SetUser(valueUser);
            }
            else {
                SetUser(newValue);
            }
        }
        else if (reason === "remove-option") {
            if (newValue.some(x => x.value === -1)) {
                var index = newValue.findIndex(x => x.value === -1);
                SetUser([...newValue.slice(0, index),
                ...newValue.slice(index + 1)]);
            }
            else if (!newValue.some(x => x.value === -1) && newValue.length === valueUser.length - 1) {
                SetUser();
            }
            else {
                SetUser(newValue);
            }
        }
        else if (reason === "clear") {
            SetUser();
        }
    }

    if (!props.DataMain) {
        return <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} >
            <CircularProgress className="CircularProgress" disableShrink />
        </div>
    }
    else {
        return (
            <div className="ui1">
                <div className="body-task1">
                <Button onClick={handleTaomenu} className="buttonMenu" size="small" startIcon={<MdCreate />} variant="contained" color="primary">Tạo menu</Button>
                {/* <Button onClick={handleshowopen} className="buttonMenu" size="small" startIcon={<MdSettings />} variant="contained" color="primary">Phân quyền menu</Button> */}
                    <div style={{ display: showTaoMenu ? "block" : "none" }} className="PlanTemplate_body">
                        <Accordion className="PlanTemplate_002" expanded={expanded === 'panel1'} >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >                                
                                <Typography className={"abc"}>Tạo menu                                
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="col-md-6 PlanTemplate_0014">
                                    <TextField
                                        required
                                        id="outlined-required"
                                        variant="outlined"
                                        label="Tên menu"
                                        placeholder="Kế hoạch Deploy"
                                        onChange={(event) => handleMenu(event)}
                                        value={valueMenu ? valueMenu: ''}
                                        size="small"
                                        style={{ width: "100%", fontSize: "10px" }}
                                    />
                                </div>
                                <div className="col-md-6 PlanTemplate_0014">
                                    <Autocomplete
                                        id="combo-box"
                                        limitTags={5}
                                        options={menucha}
                                        disableCloseOnSelect
                                        size="small"
                                        getOptionLabel={(option) => option.title}
                                        style={{ width: "100%" }}
                                        renderInput={(params) => <TextField {...params} InputLabelProps={{
                                            shrink: true,
                                        }}  id="outlined-required" label="Menu Cha" variant="outlined" />}
                                        className="PlanTemplate_0013"
                                        value={valueMenucha ? valueMenucha : null}
                                        onChange={(event, newValue) => fn_SetMenuCha(newValue)}
                                    />
                                </div>
                                <div className="col-md-6 PlanTemplate_0014">
                                    <TextField
                                        required
                                        id="outlined-required"
                                        variant="outlined"
                                        label="Đường dẫn"
                                        placeholder="/PlanTemplate/Main"
                                        onChange={handlePath}
                                        value={Path}
                                        size="small"
                                        style={{ width: "100%", fontSize: "10px" }}
                                    />
                                </div>
                                <div className="col-md-6 PlanTemplate_0014">
                                    <TextField
                                        required
                                        id="outlined-required"
                                        variant="outlined"
                                        label="Level"
                                        placeholder="10"                                        
                                        onChange={handleLevel}
                                        size="small"
                                        style={{ width: "100%", fontSize: "10px" }}
                                        type="Number"
                                    />
                                </div>
                                <div className="col-md-6 PlanTemplate_0014">
                                    <TextField
                                        required
                                        id="outlined-required"
                                        variant="outlined"
                                        label="Mô tả"
                                        placeholder="10"
                                        onChange={handleDescription}
                                        size="small"
                                        style={{ width: "100%", fontSize: "10px" }}
                                    />
                                </div>
                            </AccordionDetails>
                            <AccordionActions className="PlanTemplate_btnAction">
                                <Button onClick={saveTask} className="PlanTemplate_0021" size="small" startIcon={<MdSave />} variant="contained" color="primary">Lưu</Button>
                            </AccordionActions>
                        </Accordion>
                    </div>
                    <div style={{ display: showform ? "block" : "none" }} className="PlanTemplate_body">
                        <Accordion className="PlanTemplate_002" expanded={expanded === 'panel1'} >
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header"
                            >
                                <Typography className={"abc"}>Phân quyền menu</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className="col-md-6 PlanTemplate_0014">
                                <Autocomplete
                                        id="combo-box"
                                        limitTags={5}
                                        options={menuAuthor}
                                        disableCloseOnSelect
                                        size="small"
                                        getOptionLabel={(option) => option.title}
                                        style={{ width: "100%" }}
                                        renderInput={(params) => <TextField {...params} InputLabelProps={{
                                            shrink: true,
                                        }} margin="dense" label="Menu" variant="outlined" />}
                                        className="PlanTemplate_0013"
                                        value={valueMenuAuthor}
                                        onChange={(event, newValue) => fn_SetMenuAuthor(newValue)}
                                    />
                                </div>
                                <div className="col-md-6 PlanTemplate_0014">
                                    <Autocomplete
                                        multiple
                                        id="combo-box"
                                        limitTags={5}
                                        options={valueThaotac}
                                        disableCloseOnSelect
                                        renderOption={(option, { selected }) => (
                                            <React.Fragment>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                <Typography noWrap style={{ fontSize: "13px" }}>{option.title}</Typography>
                                            </React.Fragment>
                                        )}
                                        size="small"
                                        getOptionLabel={(option) => option.title}
                                        style={{ width: "100%" }}
                                        renderInput={(params) => <TextField {...params} InputLabelProps={{
                                            shrink: true,
                                        }} margin="dense" label="Thao tác" variant="outlined" />}
                                        className="PlanTemplate_0013"
                                        value={Operation}
                                        onChange={(event, newValue, reason) => fn_Setoperation(newValue, reason)}
                                    />
                                </div>
                                <div className="col-md-6 PlanTemplate_0014">
                                <Autocomplete
                                    multiple
                                    id="combo-box"
                                    limitTags={5}
                                    options={DataUser}
                                    renderOption={(option, { selected }) => (
                                        <React.Fragment>
                                            <ThemeProvider theme={theme}>
                                                <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={selected}
                                                />
                                                <Typography noWrap style={{ fontSize: "13px" }}>{option.title}</Typography>
                                            </ThemeProvider>

                                        </React.Fragment>
                                    )}
                                    size="small"
                                    getOptionLabel={(option) => option.title}
                                    style={{ width: "100%" }}
                                    renderInput={(params) => <TextField {...params} InputLabelProps={{
                                        shrink: true,
                                    }} margin="dense" label="User" variant="outlined" />}
                                    className="PlanHandle_0013"
                                    value={User}
                                    onChange={(event, newValue, reason) => fn_SetUser(newValue, reason)}
                                />
                                </div>
                                <div className="col-md-6 PlanTemplate_0014">
                                </div>
                            </AccordionDetails>
                            <AccordionActions className="PlanTemplate_btnAction">
                                <Button onClick={savepermission} className="PlanTemplate_0021" size="small" startIcon={<MdSave />} variant="contained" color="primary">Lưu</Button>
                                <Button onClick={handleshowclose} className="PlanTemplate_0021" size="small" startIcon={<MdClose />} variant="contained" color="primary">Đóng</Button>
                            </AccordionActions>
                        </Accordion>
                    </div>
                </div>
            </div>
        );
    }
}